import React, { useEffect, useState } from "react";
import Menu from "../../components/menu/Menu";
import "./ReportsDash.css";
import { useNavigate, useParams } from "react-router-dom";
import ReportsTab from "./ReportsTab";
import ApprovedClaims from "../../components/approvedClaims/ApprovedClaims";
import PendingClaims from "../../components/pendingClaims/PendingClaims";

const ReportsDash = (props) => {

  useEffect(() => {
    localStorage.removeItem("disableUnLoad");
    localStorage.removeItem("ExerBuilderEdited");
  }, [])

  let { tab2 } = useParams();
  const navigate = useNavigate();
  const [selectedTab, setSelectedTab] = useState(tab2 === "pending-claims" ? "Pending Claims" : tab2 === "approved-claims" ? "Approved Claims" : "Reports");

  const handleSelectedTab = (tab) => {
    setSelectedTab(tab);
    if (tab === "Reports" && tab2) {
      navigate("/reports");
    } else if (tab === "Pending Claims") {
      navigate("/reports/pending-claims")
    } else if (tab === "Approved Claims") {
      navigate("/reports/approved-claims")
    }
  };


  useEffect(() => {
    props.actSidebar(true);
  }, [props]);

  return (
    <div>
      <Menu title={selectedTab} />
      <div className="programs_dash_hold">
        <div className="programs_dash_top_options" style={{ paddingTop: '20px' }}>
          <div className="reports_dash_top_options">
            <div className="programs_dash_contain_opts">
              <div
                className={"programs_dash_option" + (selectedTab === "Reports" ? " p_d_option_selected" : "")}
                onClick={() => handleSelectedTab("Reports")}
              >
                Reports
              </div>
            </div>
            <div className="programs_dash_contain_opts">
              <div
                className={"programs_dash_option" + (selectedTab === "Pending Claims" ? " p_d_option_selected" : "")}
                onClick={() => handleSelectedTab("Pending Claims")}
              >
                Pending Claims
              </div>
            </div>
            <div className="programs_dash_contain_opts">
              <div
                className={"programs_dash_option" + (selectedTab === "Approved Claims" ? " p_d_option_selected" : "")}
                onClick={() => handleSelectedTab("Approved Claims")}
              >
                Approved Claims
              </div>
            </div>
          </div>
          <div style={selectedTab === "Pending Claims" ? { width: "160px", left: "110px" } : selectedTab === "Approved Claims" ? { width: "175px", left: "294px" } : { width: "80px" }} className={"p_d_selected_slide reports_dash_top_slide" + (selectedTab === "Pending Claims" ? " slide_opt_2" : "")}></div>
        </div>

        <div className="table_component_container">
          <div className="table_component_main_container">
            {
              selectedTab === "Reports" ?
                <ReportsTab />
                :
                selectedTab === "Approved Claims" ?
                  <ApprovedClaims />
                  :
                  <PendingClaims />
            }
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReportsDash;
